import { useState, useEffect } from "react";
// import { message } from "antd"; // Usamos estático por simplicidad
import { useAuth } from "../../../../hooks";
import { ReviContentApi } from "../../../../api/revi";
import { useTherapyMutations } from "../../../../hooks/revi/useTherapyMutations";

const contentApi = new ReviContentApi();

const INITIAL_STATE = {
  title: "",
  categories: [],
  image: "",
  objectives: "",
  script: "",
  visibility: "private",
};

export function useTherapyWizard({ onClose, onSuccess, initialData = null }) {
  const { accessToken, user } = useAuth();

  // Flag de edición
  const isEditing = !!initialData;

  const { create, update, processing } = useTherapyMutations({
    onSuccess: () => {
      if (onSuccess) onSuccess();
      if (onClose) onClose();
      // Limpiamos solo si no es edición
      if (!isEditing) setFormData(INITIAL_STATE);
      setCurrentStep(0);
    },
  });

  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState(INITIAL_STATE);
  const [categories, setCategories] = useState([]);

  // --- 1. LÓGICA DE CARGA DE DATOS (EDICIÓN) ---
  useEffect(() => {
    // 🕵️‍♂️ LOG DE DEPURACIÓN (Verás esto en consola)
    console.log(
      "🔄 [Wizard Hook] useEffect disparado. initialData:",
      initialData,
    );

    if (initialData) {
      console.group("📝 [WIZARD] Hidratando Formulario");

      // Mapeo defensivo de categorías: Objetos -> IDs
      const mappedCategories = (initialData.categories || []).map((cat) => {
        return typeof cat === "object" && cat !== null ? cat._id : cat;
      });

      const mappedData = {
        title: initialData.title || "",
        categories: mappedCategories,
        image: initialData.image || "",
        objectives: initialData.objectives || "", // Asegura string vacío si viene null
        script: initialData.script || "", // Asegura string vacío si viene null
        visibility: initialData.visibility || "private",
      };

      console.log("✅ Datos Mapeados:", mappedData);
      console.groupEnd();

      setFormData(mappedData);
    } else {
      console.log("⚪ Modo Crear: Reseteando formulario");
      setFormData(INITIAL_STATE);
    }
  }, [initialData]);

  // --- 2. CARGA DE RECURSOS (CATEGORÍAS) ---
  useEffect(() => {
    const loadCats = async () => {
      if (!accessToken) return;
      try {
        const data = await contentApi.getCategories(accessToken);
        setCategories(data);
      } catch (error) {
        console.error("Error cargando categorías:", error);
      }
    };
    loadCats();
  }, [accessToken]);

  // --- HANDLERS ---
  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const next = () => setCurrentStep((prev) => prev + 1);
  const prev = () => setCurrentStep((prev) => prev - 1);

  const canProceed = () => {
    if (currentStep === 0)
      return (
        formData.title.trim() &&
        formData.categories.length > 0 &&
        formData.image
      );
    if (currentStep === 1)
      return formData.objectives.trim() && formData.script.trim();
    return true;
  };

  const handleSubmit = () => {
    if (isEditing) {
      update(initialData._id, formData);
    } else {
      const payload = { ...formData, active: true, scenes: [] };
      create(payload);
    }
  };

  return {
    currentStep,
    formData,
    categories,
    loading: processing,
    user,
    handleChange,
    next,
    prev,
    canProceed,
    handleSubmit,
    isEditing,
  };
}
